import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_JOB_MINUTES_REFRESH: createSagaAction('JOB_SITE_JOB_MINUTES_REFRESH'),

  JOB_SITE_JOB_MINUTE_CREATE: createSagaAction('JOB_SITE_JOB_MINUTE_CREATE'),
  JOB_SITE_JOB_MINUTE_UPDATE: createSagaAction('JOB_SITE_JOB_MINUTE_UPDATE'),
  JOB_SITE_JOB_MINUTE_DELETE: createSagaAction('JOB_SITE_JOB_MINUTE_DELETE'),

  GET_JOB_MINUTE_TEMPLATES: createSagaAction('GET_JOB_MINUTE_TEMPLATES'),

  UPLOAD_JOB_MINUTE_ATTACHMENT: createSagaAction('UPLOAD_JOB_MINUTE_ATTACHMENT'),
  GET_JOB_MINUTE_ATTACHMENTS: createSagaAction('GET_JOB_MINUTE_ATTACHMENTS'),
  UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_JOB_MINUTE_ATTACHMENT: createSagaAction('DELETE_JOB_MINUTE_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobSiteJobMinutesRefresh: ({ jobId }) => ({
    type: constants.JOB_SITE_JOB_MINUTES_REFRESH.ACTION,
    jobId
  }),

  createJobMinute: ({ jobId, content, body, userId }) => ({
    type: constants.JOB_SITE_JOB_MINUTE_CREATE.ACTION,
    jobId,
    content,
    body,
    userId
  }),

  updateJobMinute: ({ jobId, jobMinuteId, userId, content, body }) => ({
    type: constants.JOB_SITE_JOB_MINUTE_UPDATE.ACTION,
    jobId,
    jobMinuteId,
    userId,
    content,
    body
  }),

  deleteJobMinute: ({ jobMinuteId, jobId }) => ({
    type: constants.JOB_SITE_JOB_MINUTE_DELETE.ACTION,
    jobId,
    jobMinuteId
  }),

  getJobMinuteTemplates: () => ({
    type: constants.GET_JOB_MINUTE_TEMPLATES.ACTION
  }),

  // Attachment actions
  uploadAttachment: ({ formData, jobMinuteId }) => ({
    type: constants.UPLOAD_JOB_MINUTE_ATTACHMENT.ACTION,
    formData,
    jobMinuteId
  }),

  getAttachments: ({ jobMinuteId }) => ({
    type: constants.GET_JOB_MINUTE_ATTACHMENTS.ACTION,
    jobMinuteId
  }),

  updateAttachmentDescription: ({ attachmentId, jobMinuteId, description, userId }) => ({
    type: constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    jobMinuteId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, jobMinuteId }) => ({
    type: constants.DELETE_JOB_MINUTE_ATTACHMENT.ACTION,
    attachmentId,
    jobMinuteId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_JOB_MINUTES_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_JOB_MINUTES_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteJobMinutes: action.payload
      }
    case constants.JOB_SITE_JOB_MINUTES_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_JOB_MINUTE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_JOB_MINUTE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_SITE_JOB_MINUTE_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_JOB_MINUTE_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_JOB_MINUTE_TEMPLATES.SUCCESS:
      return {
        ...state,
        jobMinuteTemplates: action.payload
      }

    case constants.UPLOAD_JOB_MINUTE_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_JOB_MINUTE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_JOB_MINUTE_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_JOB_MINUTE_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobSiteJobMinutesAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_JOB_MINUTE_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_JOB_MINUTE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteJobMinuteActions.js